import { render } from "./Streams.vue?vue&type=template&id=06dbdef9"
const script = {}

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__